import { ArrowBack } from '@mui/icons-material';
import React from 'react'
import { useNavigate } from 'react-router-dom';


function CheckinBackButton() {

    const navigate = useNavigate();

    return (
        <div className='row mt-4'>
              <div className='col-md-12'>
                <button className='btn btn-primary' onClick={()=>navigate(-1)} ><ArrowBack /> Back</button>
              </div>
        </div>
    )
}

export default CheckinBackButton